export const recurringBillText = (
  recurringBillIndex: number,
  occurrences: number,
  withTitle = false
): string => {
  const text = `${recurringBillIndex} out of ${occurrences}`;
  return withTitle ? `Recurring: ${text}` : text;
};
